import OrgChart from '../../../../components/customer/orgChart/OrgChart'

const AEACustomerOrgChart = () => {
    return <OrgChart />
}

export default AEACustomerOrgChart
